import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getPostLoginPath } from 'src/utils/navigation';

function RoleGuard({ allowedRoles = [], children, fallbackPath = null }) {
  const { user } = useSelector(state => state.account);

  if (!user) {
    return <Redirect to='/login' />;
  }

  if (user.change_password) {
    return <Redirect to='/change-password' />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Redirect to={fallbackPath || getPostLoginPath(user)} />;
  }

  return children;
}

RoleGuard.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  fallbackPath: PropTypes.string,
};

export default RoleGuard;
